import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ReservationsHeaderWrapper from '../reservations-header-wrapper'
import Grid from '@material-ui/core/Grid'
import ReviewReservationLayout from './review-reservation-layout'
import { useQuery } from '@apollo/client'
import Error from 'components/error'
import { GetStudentQuery } from '../queries'
import ReviewBookingSkeleton from 'pages/schedule/ReviewBooking/review-booking-skeleton'

const ReviewReservation = ({
  academy,
  studentId,
  startDateTime,
  practiceSession,
}) => {
  const {
    data: fetchedStudent,
    loading: studentLoading,
    error: studentError,
  } = useQuery(GetStudentQuery, {
    variables: {
      id: studentId,
    },
  })

  const { id: practiceSessionTypeId } = practiceSession

  const { pathname } = useLocation()
  const [showWaiver, setShowWaiver] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [showWaiver])

  if (studentError) {
    return <Error error={studentError} />
  }

  if (studentLoading) {
    return <ReviewBookingSkeleton />
  }

  const selectedStudent = fetchedStudent?.student

  return (
    <Grid container>
      <ReservationsHeaderWrapper
        academy={academy}
        currentStep={showWaiver ? 4 : 3}
        totalSteps={4}
        previousUrl={`${pathname}?startDateTime=${startDateTime}&practiceSessionTypeId=${practiceSessionTypeId}`}
        selectedPracticeSession={practiceSession}
      >
        <ReviewReservationLayout
          student={selectedStudent}
          showWaiver={showWaiver}
          setShowWaiver={setShowWaiver}
          selectedPracticeSession={practiceSession}
        />
      </ReservationsHeaderWrapper>
    </Grid>
  )
}

export default ReviewReservation
